import { createFileRoute } from '@tanstack/react-router';
import { LazyPage } from './-route-layouts';
import { WorkspaceCustomSmsQuietHoursPage } from './-route-pages';

function WorkspaceCustomSmsQuietHoursRoute() {
  return (
    <LazyPage>
      <WorkspaceCustomSmsQuietHoursPage />
    </LazyPage>
  );
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/settings/actions/sms-providers/quiet-hours',
)({
  component: WorkspaceCustomSmsQuietHoursRoute,
});
